<div class="card_status_actions">
  <div class="card_header">
    <h4>
      {{ "rights.statusAndActions" | translate }}
    </h4>
    <app-evaluation-task-status [status]="record.status"></app-evaluation-task-status>
  </div>
  <div class="card_body">
    <div class="container_no_action_needed border-0"
      *ngIf="availableActions.actions && !availableActions.actions.length && record.status && record.status.statusCode == evaluationTaskStatus.Final_Report_Approved;else noActions">
      <img src="assets/images/illu_published.png" alt="">
      <p class="desc_actions">
        {{ "evaluationTasks.evaluationApproved" | translate }} <br />
        {{ "evaluationTasks.noActionRequiredAtTheMoment" | translate }}
      </p>
    </div>
    <ng-template #noActions>
      <div class="container_no_action_needed" [class.border-0]="!availableActions.actions.length"
        *ngIf="availableActions.actions && !availableActions.actions.length">
        <img src="assets/images/illu_no_action_needed.png" alt="">
        <p class="desc_actions">
          {{ "rights.noActionRequired" | translate }}
        </p>
      </div>
    </ng-template>

    <ng-container *ngIf="availableActions.messages && availableActions.messages.length">
      @for (item of availableActions.messages; track $index) {
      <img *ngIf="item.image" [src]="'assets/images/' + item.image" alt="">
      <p class="desc_actions">
        {{ item.message }}
      </p>
      }
      <hr class="divider_actions">
    </ng-container>

    @if (availableActions && availableActions.actions && availableActions.actions.length) {
    <p class="label_actions text-center">
      {{ "rights.availableActions" | translate }}
    </p>

    @for (action of availableActions.actions; track action.actionId){
    <button mat-raised-button type="button" [disabled]="loading" [class]="action.class" [class.loading]="loading"
      (click)="handleClick(action)">
      <span>{{action.title}}</span>
    </button>
    }
    }
  </div>
</div>